import React, { useEffect, useState } from 'react';
import EcranPassage from '../components/connexion/EcranPassage';
import { lireEcrans, momentPour, segments, civiliteDe } from '../components/connexion/contenusEcrans';

/**
 * Écran d'au revoir de l'administration, à la déconnexion : l'école s'endort —
 * le soleil descend, les élèves s'en vont, les fenêtres s'éteignent.
 * Textes et horaires journée/soirée réglés dans le CIK.
 * Ancienne version : components/dump/GoodbyeScreen-V1-avant-refonte.jsx
 */
const GoodbyeScreen = ({ user }) => {
  const [ecrans] = useState(lireEcrans);
  const [moment] = useState(() => momentPour(ecrans.horaires));

  useEffect(() => {
    // AdministrationLayout redirige aussi, par secours, au bout de 3 s
    const timeout = setTimeout(() => {
      window.location.href = '/connexion';
    }, 2500);

    return () => clearTimeout(timeout);
  }, []);

  const valeurs = { civilite: civiliteDe(user?.sexe), nom: user?.nom };
  const textes = ecrans.au_revoir;

  return (
    <EcranPassage
      sens="depart"
      moment={moment}
      titre={segments(textes[moment], valeurs, [])}
      phrase={segments(textes.fin, valeurs, [])}
      icone="sortie"
      duree={2.5}
    />
  );
};

export default GoodbyeScreen;
